// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import {
    selectAppStatus,
    selectAppError,
} from '../../../features/app/appSlice';

// Components
import StateHandler from '../StateScreen/StateHandler';

// Constants
import { ERROR_EXPIRED_TOKEN } from '../../../utils/constants/constants';

/**
 * @function Login
 * Describe the component's function
 *
 * @example
 * return (
 *   <Login />
 * )
 */
function Login(): JSX.Element {
    const appStatus = useAppSelector(selectAppStatus);
    const appError = useAppSelector(selectAppError);

    if (appStatus !== 'idle') {
        return (
            <StateHandler
                status={appStatus}
                error={appError}
                loadingText="Logging in..."
            />
        );
    }

    return (
        <StateHandler
            status="failed"
            error={ERROR_EXPIRED_TOKEN}
            loadingText="Logging in..."
        />
    );
}

// Exports
export default Login;
